import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, IconButton, Divider, Stack } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const Footer: React.FC = () => {
  return (
    <Box component="footer" sx={{ bgcolor: 'black', color: 'white', py: 8, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CameraAltIcon sx={{ mr: 1 }} />
              <Typography variant="h6" fontWeight={700}>
                ScreenShot API
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255,255,255,0.7)' }}>
              A powerful and easy-to-use screenshot API for developers. 
              Capture any website/html with just a simple API call.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton 
                href="https://github.com/akshaypose" 
                target="_blank"
                sx={{ 
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                }}
              >
                <GitHubIcon />
              </IconButton>
              <IconButton 
                href="https://in.linkedin.com/in/akshaypose" 
                target="_blank"
                sx={{ 
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                }}
              >
                <LinkedInIcon />
              </IconButton>
            </Stack>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 4 }}>
            <Box>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Product
              </Typography>
              <Stack spacing={1}>
                <Typography 
                  component={Link} 
                  to="/pricing" 
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  Pricing
                </Typography>
                <Typography 
                  component={Link} 
                  to="/api-docs" 
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  API Documentation
                </Typography>
                <Typography 
                  component="a" 
                  href="#features" 
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  Features
                </Typography>
              </Stack>
            </Box>

            <Box>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Support
              </Typography>
              <Stack spacing={1}>
                <Typography 
                  component={Link} 
                  to="/support" 
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  Help Center
                </Typography>
                <Typography 
                  component="a" 
                  href="https://merchant.razorpay.com/policy/RcmfOe3WxTO3pw/contact_us" 
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  Contact Us
                </Typography>
              </Stack>
            </Box>

            <Box>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Legal
              </Typography>
              <Stack spacing={1}>
                <Typography 
                  component="a" 
                  href="https://merchant.razorpay.com/policy/RcmfOe3WxTO3pw/terms" 
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  Terms & Conditions
                </Typography>
                <Typography 
                  component="a" 
                  href="https://merchant.razorpay.com/policy/RcmfOe3WxTO3pw/privacy" 
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  Privacy Policy
                </Typography>
                <Typography 
                  component="a" 
                  href="https://merchant.razorpay.com/policy/RcmfOe3WxTO3pw/refund" 
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  Cancellation & Refunds
                </Typography>
                <Typography 
                  component="a" 
                  href="https://merchant.razorpay.com/policy/RcmfOe3WxTO3pw/shipping" 
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2" 
                  sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: 'white' } }}
                >
                  Shipping Policy
                </Typography>
              </Stack>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
            © {new Date().getFullYear()} ScreenShot API. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
